@if (diagnosisWithTreatmentControl.get('treatmentsList')?.value &&
diagnosisWithTreatmentControl.get('treatmentsList')?.value.length > 0) {
<div class="full-width remove-max-width  form-card overflow-auto ">
  <table mat-table [dataSource]="diagnosisWithTreatmentControl.get('treatmentsList')?.value"
    id="tblPrescriptionTreatments" multiTemplateDataRows>
    <ng-container matColumnDef="expandState">
      <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
      <td mat-cell *matCellDef="let element; let i = dataIndex" class="width-icon-expand">
        <mat-icon class="clickable" [id]="'btnExpandDosis' + i">
          {{ element.expanded ? "expand_less" : "expand_more" }}
        </mat-icon>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef>
        <div class="padding-right-10">
          {{
          "reporting.prescription.table.column.type"
          | translate
          }}
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <mat-form-field appearance="outline">
          <mat-select [formControl]="element.type" (click)="$event.stopPropagation()"
            [id]="'somType' + element.salesArticleId" (selectionChange)="typeChange($event, element)">
            @for (prescriptionType of prescriptionTypeDropdownList; track prescriptionType) {
            <mat-option [value]="prescriptionType">
              <div>
                @switch (prescriptionType) {
                @case(PrescriptionType.SUPPLY_FARM_ANIMAL_TREATMENT) {
                <span>
                  {{ 'reporting.prescription.type.delivery.stock' | translate }}
                </span>
                }
                @case (PrescriptionType.SINGLE_FARM_ANIMAL_TREATMENT) {
                <span>
                  {{ 'reporting.prescription.type.single.animal.treatment' | translate }}
                </span>
                }
                }
              </div>
            </mat-option>
            }

          </mat-select>
        </mat-form-field>
      </td>
    </ng-container>
    <ng-container matColumnDef="medicineDescription">
      <th mat-header-cell *matHeaderCellDef>
        <div class="padding-right-10">
          {{
          "medicalHistory.modify.prescriptionHex.treatmentsTable.column.medicineDescription.title"
          | translate
          }}
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="width-min-200">
          {{ element.medicineDescription }}
          @if (element.hexDescription) {
          <ng-container>
            <br>({{ element.hexDescription }})
          </ng-container>
          }
          @if (element.isCriticalAntibiotic) {
          <p class="error" id="spnIsCriticalAntibiotic"> {{
            'visit.prescriptions.isCriticalAntibiotic.error' | translate }} </p>
          }
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="totalDosis">
      <th mat-header-cell *matHeaderCellDef>
        <div class="padding-right-10">
          {{
          "medicalHistory.modify.prescriptionHex.treatmentsTable.column.totalAmountInstructions.title"
          | translate
          }}
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="width-max-content">
          <span class="flex-v-center " [class.error]="element.totalDosis > element.totalDeliveryQuantity">
            @if (element.totalDosis > element.totalDeliveryQuantity) {
            <mat-icon class="error" id="imgTotalDeliveryQuantityError">priority_high</mat-icon>
            }

            {{ (element.totalDosis | number: '1.2') }} {{ element.unit }} =
            {{ element.hexTotalDosis | number: '1.2'}} {{ element.hexUnit}}
          </span>
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="totalDeliveryQuantity">
      <th mat-header-cell *matHeaderCellDef>
        <div class="padding-right-10">
          {{
          "medicalHistory.modify.prescriptionHex.treatmentsTable.column.totalAmountTreatment.title"
          | translate
          }}
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="width-max-content">
          <span [class.error]="element.totalDosis > element.totalDeliveryQuantity">
            {{ element.totalDeliveryQuantity | number: '1.2'}} {{ element.unit}} =
            {{ element.hexTotalDeliveryQuantity | number: '1.2' }} {{ element.hexUnit}}
          </span>
        </div>

      </td>
    </ng-container>
    @if (treatmentPrescriptions.length > 1) {
    <ng-container matColumnDef="diagnosis">
      <th mat-header-cell *matHeaderCellDef>
        <div class="padding-right-10">
          {{
          "medicalHistory.modify.prescriptionHex.treatmentsTable.column.diagnosis.title"
          | translate
          }}
        </div>
      </th>
      <td mat-cell *matCellDef="let element; let i = dataIndex;">
        @if (diagnosis.controls && diagnosis.controls.length > 1 && element.type !==
        PrescriptionType.SUPPLY_FARM_ANIMAL_TREATMENT) {
        <div>
          @for (itemDiagnosis of diagnosis.controls; track itemDiagnosis; let indexDiagnosis = $index) {
          <div>
            @if (indexDiagnosis !== diagnosisWithTreatmentIndex && itemDiagnosis.get('diagnosisLevel2')?.value) {
            <a href="#"
              [id]="'btnChangeTreatmentDiagnosis' + '-' + i"
              (click)="handleChangingTreatmentDiagnosis($event, element, itemDiagnosis.get('diagnosisLevel2')?.value,  diagnosis.controls[diagnosisWithTreatmentIndex])">
              verschieben zu {{getDiangnosisLevelText(itemDiagnosis.get('diagnosisLevel2')?.value)}}</a>
            }
          </div>
          }
        </div>
        }
      </td>
    </ng-container>
    }

    <ng-container matColumnDef="startDateInstructions">
      <th mat-header-cell *matHeaderCellDef>
        <div class="padding-right-10">
          {{
          "medicalHistory.modify.dosisModal.startOfTreatment.label"
          | translate
          }}
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        @if (element.type !== PrescriptionType.SUPPLY_FARM_ANIMAL_TREATMENT) {
        <div>
          @if (element.startDateInstructions) {
          <mat-form-field appearance="outline" class="width-200">
            <input placeholder="dd.mm.yyyy" bsDatepicker matInput [formControl]="element.startDateInstructions"
              (click)="$event.stopPropagation();" />
            <mat-icon matSuffix [class.disabled-icon-opacity]="element.startDateInstructions.disabled"
              (click)="$event.stopPropagation();showCalendarPage(element.startDateInstructions)">
              calendar_today
            </mat-icon>
          </mat-form-field>
          }
        </div>
        }

      </td>
    </ng-container>
    <ng-container matColumnDef="endDateInstructions">
      <th mat-header-cell *matHeaderCellDef>
        <div class="padding-right-10">
          {{
          "medicalHistory.modify.dosisModal.endOfTreatment.label"
          | translate
          }}
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        @if (element.type !== PrescriptionType.SUPPLY_FARM_ANIMAL_TREATMENT) {
        <div>
          @if (element.endDateInstructions) {
          <mat-form-field appearance="outline" class="width-200">
            <input placeholder="dd.mm.yyyy" bsDatepicker matInput [formControl]="element.endDateInstructions"
              (click)="$event.stopPropagation();" />
            <mat-icon matSuffix [class.disabled-icon-opacity]="element.endDateInstructions.disabled"
              (click)="$event.stopPropagation();showCalendarPage(element.endDateInstructions)">
              calendar_today
            </mat-icon>
          </mat-form-field>
          }
        </div>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="isIsabv">
      <th mat-header-cell *matHeaderCellDef>
        <div class="padding-right-10">
          {{
          "medicalHistory.modify.prescriptionHex.treatmentsTable.column.isabvCheckbox.title"
          | translate
          }}
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        @if (element.isTransferISABV) {
        <div>
          <ng-container
            *ngTemplateOutlet="cancelIcon; context: { value: element,  PrescriptionStatus: PrescriptionStatus}">
          </ng-container>
          @if (element.isabvState !== PrescriptionStatus.CANCELED && element.tapsState !== PrescriptionStatus.CANCELED
          &&
          element.isabvState !== PrescriptionStatus.RESENT && element.tapsState !== PrescriptionStatus.RESENT) {
          <mat-checkbox (click)="$event.stopPropagation()" [checked]="element.isIsabv" [formControl]="element.isIsabv">
          </mat-checkbox>
          }
        </div>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="isTaps">
      <th mat-header-cell *matHeaderCellDef>
        <div class="padding-right-10">
          {{
          "medicalHistory.modify.prescriptionHex.treatmentsTable.column.ebjzoCheckbox.title"
          | translate
          }}
        </div>
      </th>
      <td mat-cell *matCellDef="let element">
        @if (element.isTransferTAPS) {
        <div>
          <ng-container
            *ngTemplateOutlet="cancelIcon; context: { value: element,  PrescriptionStatus: PrescriptionStatus}">
          </ng-container>
          @if (element.isabvState !== PrescriptionStatus.CANCELED && element.tapsState !== PrescriptionStatus.CANCELED
          &&
          element.isabvState !== PrescriptionStatus.RESENT && element.tapsState !== PrescriptionStatus.RESENT) {
          <mat-checkbox (click)="$event.stopPropagation()" [checked]="element.isTaps" [formControl]="element.isTaps">
          </mat-checkbox>
          }
        </div>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let element; let i = index" [attr.colspan]="displayedColumns.length">
        <div class="expand-element-details" [@detailExpand]="element.expanded ? 'expanded' : 'collapsed'">
          @if (element.type.value === PrescriptionType.SINGLE_FARM_ANIMAL_TREATMENT) {
          <div class="padding-10">
            @if (applicationTypes && applicationTypes.length > 0 && servingModes && servingModes.length > 0 &&
            element.startDateInstructions.value) {
            <diana-add-dosis [applicationTypes]="applicationTypes" [servingModes]="servingModes"
              [showApplicationType]="true" [treatmentUnit]="element.hexUnit || ''"
              [formGroup]="element.dosagesFormGroup" [visitAt]="element.startDateInstructions.value"
              [idHtmlElements]="element.salesArticleId" [treatmentInstruction]="element.treatmentInstruction"
              (durationInDaysChanged)="setEndDateIntructions(element, $event); diagnosis.markAsDirty();"
              (amountChanged)="element.hexTotalDosis = $event; diagnosis.markAsDirty(); setDosis(element.hexTotalDosis, element);">
            </diana-add-dosis>
            }
          </div>
          }

          @if (element.type.value === PrescriptionType.SUPPLY_FARM_ANIMAL_TREATMENT) {
          <div class="padding-10">
            <diana-delivery-on-stock-details [deliveryOnStockDosageFormGroup]="element.deliveryOnStockDosageFormGroup"
              [idHtmlElements]="element.salesArticleId" [visitAt]="element.startDateInstructions.value"
              (endDateChanged)="setEndDateIntructions(element, $event);  element.deliveryOnStockDosageFormGroup.markAsDirty();"
              (totalDeliveryChanged)="element.hexTotalDosis = $event; diagnosis.markAsDirty(); setDosis(element.hexTotalDosis, element);">
            </diana-delivery-on-stock-details>
          </div>
          }
        </div>
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let element; columns: displayedColumns;" (click)="toggleRow(element)">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="expand-details-row"></tr>
  </table>
</div>
}


<ng-template #cancelIcon let-value="value" let-PrescriptionStatus="PrescriptionStatus">
  @if (value.isabvState === PrescriptionStatus.CANCELED || value.tapsState === PrescriptionStatus.CANCELED ||
  value.isabvState === PrescriptionStatus.RESENT || value.tapsState === PrescriptionStatus.RESENT) {
  <mat-icon>
    cancel
  </mat-icon>
  }
</ng-template>